import {
  gaqlenumARGRES as ARGRES
} from './gaqlenum.js'

const gaqltargetArgsIs = obj => Boolean(obj
  && typeof obj === 'object'
  && ARGRES in obj)

const gaqltargetArgsParse = obj =>
  obj[ARGRES]

const gaqltargetArgsCreate = value =>
  ({ [ARGRES]: value })

export {
  gaqltargetArgsIs,
  gaqltargetArgsParse,
  gaqltargetArgsCreate
}
